import { Button } from "@/components/ui/button";
import TopupCountdown from "@/components/topup-countdown";

const SuccessNotice = ({
  type,
  transaction,
  closeModal,
}: {
  type:
    | "withdrawal"
    | "deposit"
    | "card-topup"
    | "card-withdrawal"
    | "add-contact"
    | "internal-transfer"
    | "register"
    | "statement";
  transaction?: {
    id: number | string;
    amount: string | number;
    createdAt: string;
  };
  closeModal: () => void;
}) => {
  if (type === "statement")
    return (
      <div className="my-4 flex w-full flex-col items-center gap-4">
        <img
          src="/icons/success-arrow-badge.svg"
          alt=""
          className="size-[66px]"
        />
        <div className="mt-2 text-2xl font-medium">Statement downloaded</div>
        <p className="text-dark-text-300 -mt-2 max-w-[80%] text-center text-xs font-light">
          Check your downloads for the PDF file.
        </p>
        <div className="mt-4 flex w-full items-center gap-2">
          <Button
            onClick={closeModal}
            className="text-dark-text-400 bg-dark-primary-gradient h-11 grow hover:opacity-90"
          >
            Done
          </Button>
        </div>
      </div>
    );

  if (type === "deposit")
    return (
      <div className="my-4 flex w-full flex-col items-center gap-4">
        <img
          src="/icons/success-arrow-badge.svg"
          alt=""
          className="size-[66px]"
        />
        <div className="mt-2 text-2xl font-medium">Deposit successful</div>
        <div className="mt-4 flex w-full items-center gap-2">
          <Button
            onClick={closeModal}
            className="text-dark-text-400 bg-dark-primary-gradient h-11 grow hover:opacity-90"
          >
            Continue
          </Button>
          <Button
            onClick={closeModal}
            className="border-dark-primary-main hover:bg-dark-primary-100 text-dark-text-50 h-11 grow border bg-transparent"
          >
            See Details
          </Button>
        </div>
      </div>
    );

  if (type === "internal-transfer")
    return (
      <div className="my-4 flex w-full flex-col items-center gap-4">
        <img
          src="/icons/success-arrow-badge.svg"
          alt=""
          className="size-[66px]"
        />
        <div className="mt-2 text-2xl font-medium">Transfer successful</div>
        <p className="text-dark-text-300 text-center text-sm">
          Your transfer is on its way and usually arrives in less than 5 mins.
        </p>
        <Button
          onClick={closeModal}
          className="text-dark-text-400 bg-dark-primary-gradient mt-2 h-11 w-full"
        >
          Done
        </Button>
      </div>
    );

  if (type === "withdrawal")
    return (
      <div className="my-4 flex w-full flex-col items-center gap-4">
        <img
          src="/icons/success-arrow-badge.svg"
          alt=""
          className="size-[66px]"
        />
        <div className="mt-2 text-2xl font-medium">Withdrawal successful</div>
        <div className="mt-4 flex w-full items-center gap-2">
          <Button
            onClick={closeModal}
            className="text-dark-text-400 bg-dark-primary-gradient h-11 grow hover:opacity-90"
          >
            Continue
          </Button>
          <Button
            onClick={closeModal}
            className="border-dark-primary-main hover:bg-dark-primary-100 text-dark-text-50 h-11 grow border bg-transparent"
          >
            See Details
          </Button>
        </div>
      </div>
    );

  if (type === "card-topup")
    return (
      <div className="my-4 w-full">
        <div className="flex flex-col items-center gap-2">
          <img
            src="/icons/success-check-badge.svg"
            alt=""
            className="size-[50px]"
          />
          <div className="text-2xl font-medium">Card Top-Up Processing</div>
          <p className="text-dark-text-300 text-center text-sm">
            Your top-up has been submitted and is being processed.
          </p>
        </div>
        {transaction ? (
          <TopupCountdown
            createdAt={transaction.createdAt}
            transactionId={transaction.id}
            amount={transaction.amount}
          />
        ) : (
          <TopupCountdown
            createdAt={new Date().toISOString()}
            transactionId="-"
            amount="-"
          />
        )}
        <div className="mt-4">
          <Button
            onClick={closeModal}
            className="text-dark-text-400 bg-dark-primary-gradient h-11 w-full hover:opacity-90"
          >
            Done
          </Button>
        </div>
      </div>
    );

  if (type === "card-withdrawal")
    return (
      <div className="my-4 flex w-full flex-col items-center gap-4">
        <img
          src="/icons/success-arrow-badge.svg"
          alt=""
          className="size-[66px]"
        />
        <div className="mt-2 text-2xl font-medium">
          Card Withdrawal successful
        </div>
        <div className="mt-4 flex w-full items-center gap-2">
          <Button
            onClick={closeModal}
            className="text-dark-text-400 bg-dark-primary-gradient h-11 grow hover:opacity-90"
          >
            Continue
          </Button>
          <Button
            onClick={closeModal}
            className="border-dark-primary-main hover:bg-dark-primary-100 text-dark-text-50 h-11 grow border bg-transparent"
          >
            See Details
          </Button>
        </div>
      </div>
    );

  if (type === "add-contact")
    return (
      <div className="my-4 flex w-full flex-col items-center gap-4">
        <img
          src="/icons/success-arrow-badge.svg"
          alt=""
          className="size-[66px]"
        />
        <div className="mt-2 text-2xl font-medium">
          Contact added successfully
        </div>
        <div className="mt-4 flex w-full items-center gap-2">
          <Button
            onClick={closeModal}
            className="text-dark-text-400 bg-dark-primary-gradient h-11 grow hover:opacity-90"
          >
            Close
          </Button>
        </div>
      </div>
    );

  if (type === "register")
    return (
      <div className="my-4 flex w-full flex-col items-center gap-4">
        <img src="/icons/register-badge.svg" alt="" className="size-[66px]" />
        <div className="mt-2 text-2xl font-medium">
          Account created successfully
        </div>
        <div className="mt-4 flex w-full items-center gap-2">
          <Button
            onClick={() => (window.location.href = "/login")}
            className="text-dark-text-400 bg-dark-primary-gradient h-11 grow hover:opacity-90"
          >
            Continue to Login
          </Button>
        </div>
      </div>
    );
};

export default SuccessNotice;
